import React, { Component } from 'react';
import './Account.css'
import AccountHeader from './AccountHeader';
import {
    Card,
    Table,
    Button,
    DatePicker,
    Row,
    Col,
    Statistic,
    Tag,
    Empty,
    Spin,
    Tabs,
    Modal,
    message
} from 'antd';
import {
    CalendarOutlined,
    SearchOutlined,
    FileTextOutlined,
    ExclamationCircleOutlined,
    DeleteOutlined
} from '@ant-design/icons';
import {
    get_data_token,
    GET_TRANSACTION_LIST,
    GET_RESERVE_LIST,
    COMMIT_CANCEL,
} from '../../config/network'
import { showErrorMessage } from '../MessageBox';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { confirm } = Modal;

class Transactions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            records: [],
            reservations: [],
            activeTab: '1',
            startDate: this.getInitStartTimeStr(),
            endDate: this.formatDate(new Date()),
            load: false,
            loadReservations: false,
            Confirmvisible: false,
        };

        this.getTransactions = this.getTransactions.bind(this);
        this.getReservations = this.getReservations.bind(this);
        this.handleChangeStartTime = this.handleChangeStartTime.bind(this);
        this.handleChangeEndTime = this.handleChangeEndTime.bind(this);
        this.checkDateInput = this.checkDateInput.bind(this);
        this.cancelReservation = this.cancelReservation.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
    }

    componentDidMount() {
        this.getTransactions();
        this.getReservations();
    }

    onTabChange(key) {
        this.setState({ activeTab: key });
        if (key === '2') {
            this.getReservations();
        }
    }

    //
    getTransactions() {

        this.setState({ load: true })
        get_data_token(GET_TRANSACTION_LIST, {
            startime: new Date(this.state.startDate).getTime() / 1000,
            endtime: new Date(this.state.endDate).getTime() / 1000,
        })
            .then(data => {
                // Handle transaction data - could be data.data, data.transactionList, or data.storeList
                const transactionData = data.data || data.transactionList || data.storeList || [];
                transactionData.map(record => record.key = record.rental_id);
                this.setState({ records: transactionData, load: false });
                // console.log("getTransactions", transactionData)
            })
            .catch(
                err => {
                    this.setState({ records: [], load: false });
                    //showErrorMessage.call(this, 'Get transactions error:' + err);
                })

    }

    //
    getReservations() {
        this.setState({ loadReservations: true })
        get_data_token(GET_RESERVE_LIST, {
            startime: new Date(this.state.startDate).getTime() / 1000,
            endtime: new Date(this.state.endDate).getTime() / 1000,
        })
            .then(data => {
                // Handle reservation data - could be data.data, data.reserveList, or other structure
                const reservationData = data.data || data.reserveList || data.storeList || [];
                reservationData.map(record => record.key = record.reserve_id || record.rental_id || record.storeId);
                this.setState({ reservations: reservationData, loadReservations: false });
            })
            .catch(err => {
                this.setState({ reservations: [], loadReservations: false });
                //showErrorMessage.call(this, 'Get reservations error:' + err);
            })
    }

    cancelReservation(record) {
        const reserveId = record.reserve_id || record.rental_id || record.storeId;
        confirm({
            title: 'Cancel Reservation',
            icon: <ExclamationCircleOutlined />,
            content: `Are you sure you want to cancel this reservation?`,
            okText: 'Yes, Cancel',
            okType: 'danger',
            cancelText: 'No',
            onOk: () => {
                get_data_token(COMMIT_CANCEL, { reserveId: reserveId })
                    .then(data => {
                        message.success('Reservation canceled successfully');
                        this.getReservations(); // Refresh the list
                    })
                    .catch(err => {
                        message.error('Failed to cancel reservation: ' + err);
                    });
            },
        });
    }

    getInitStartTimeStr() {

        let d = new Date(Date.now() - 1000 * 86400 * 30);
        return this.formatDate(d);
    }
    formatDate(date) {

        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }
    checkDateInput(dateStr) {
        if (dateStr.search(/^\d{4}-\d{2}-\d{2}$/) === -1) {
            showErrorMessage.call(this, 'Please input right date format: yyyy-mm-dd')
            return false;
        }

        return true;
    }
    handleChangeStartTime(event) {
        if (!this.checkDateInput(event.target.value))
            return;
        this.setState({
            startDate: event.target.value
        });
    }
    handleChangeEndTime(event) {
        if (!this.checkDateInput(event.target.value))
            return;
        this.setState({
            endDate: event.target.value
        });
    }


    renderRecords() {
        if (this.state.load) {
            return (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Spin size="large" />
                    <div style={{ marginTop: '16px' }}>Loading transactions...</div>
                </div>
            );
        }

        if (this.state.records.length === 0) {
            return (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No transactions found"
                    style={{ padding: '50px' }}
                />
            );
        }

        const columns = [
            {
                title: 'Rental ID',
                dataIndex: 'rental_id',
                key: 'rental_id',
                render: (text) => <Tag color="blue">{text}</Tag>
            },
            {
                title: 'Product Name',
                dataIndex: 'product_name',
                key: 'product_name',
                render: (text) => <strong>{text}</strong>
            },
            {
                title: 'Brand',
                dataIndex: 'brand',
                key: 'brand',
                render: (text) => <Tag color="green">{text}</Tag>
            },
            {
                title: 'Cabinet ID',
                dataIndex: 'cabinet_id',
                key: 'cabinet_id',
                render: (text) => <Tag color="purple">{text}</Tag>
            },
            {
                title: 'Rental Time',
                dataIndex: 'rental_time',
                key: 'rental_time',
                render: (text) => moment.unix(text).format('YYYY-MM-DD HH:mm:ss')
            },
            {
                title: 'Return Time',
                dataIndex: 'return_time',
                key: 'return_time',
                render: (text) => text ? moment.unix(text).format('YYYY-MM-DD HH:mm:ss') : 'Not Returned'
            }
        ];

        return (
            <Table
                columns={columns}
                dataSource={this.state.records}
                rowKey="rental_id"
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} transactions`
                }}
            />
        );
    }

    renderReservations() {
        if (this.state.loadReservations) {
            return (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Spin size="large" />
                    <div style={{ marginTop: '16px' }}>Loading reservations...</div>
                </div>
            );
        }

        if (this.state.reservations.length === 0) {
            return (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No reservations found"
                    style={{ padding: '50px' }}
                />
            );
        }

        const columns = [
            {
                title: 'Reserve ID',
                dataIndex: 'reserve_id',
                key: 'reserve_id',
                render: (text, record) => <Tag color="blue">{text || record.rental_id || record.storeId}</Tag>
            },
            {
                title: 'Product Name',
                dataIndex: 'product_name',
                key: 'product_name',
                render: (text, record) => <strong>{text || record.productName}</strong>
            },
            {
                title: 'Cabinet ID',
                dataIndex: 'cabinet_id',
                key: 'cabinet_id',
                render: (text, record) => <Tag color="purple">{text || record.cabinetId}</Tag>
            },
            {
                title: 'Reserve Time',
                dataIndex: 'reserve_time',
                key: 'reserve_time',
                render: (text, record) => {
                    const time = text || record.storeTime || record.reserveTime;
                    return time ? moment.unix(time).format('YYYY-MM-DD HH:mm:ss') : 'N/A';
                }
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render: (text, record) => (
                    <Tag color="orange">Reserved</Tag>
                )
            },
            {
                title: 'Action',
                key: 'action',
                render: (text, record) => (
                    <Button
                        type="primary"
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => this.cancelReservation(record)}
                    >
                        Cancel
                    </Button>
                )
            }
        ];

        return (
            <Table
                columns={columns}
                dataSource={this.state.reservations}
                rowKey={record => record.reserve_id || record.rental_id || record.storeId}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} reservations`
                }}
            />
        );
    }

    render() {
        const statsData = {
            transactions: this.state.records.length,
            reservations: this.state.reservations.length,
            thisMonth: this.state.records.filter(r =>
                moment(r.storeTime).month() === moment().month()
            ).length,
            pendingPickup: this.state.records.filter(r => !r.pickTime).length
        };

        return (
            <div className="dashboard-container">
                <AccountHeader
                    page={"Transactions"}
                    title="Your Transactions & Reservations"
                />

                <div className="dashboard-content">
                    {/* Stats Cards */}
                    <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
                        <Col xs={24} sm={12} lg={6}>
                            <Card bordered={false} className="status-card">
                                <Statistic
                                    title="Total Transactions"
                                    value={statsData.transactions}
                                    prefix={<FileTextOutlined />}
                                    valueStyle={{ color: '#1890ff' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} lg={6}>
                            <Card bordered={false} className="status-card">
                                <Statistic
                                    title="Active Reservations"
                                    value={statsData.reservations}
                                    prefix={<CalendarOutlined />}
                                    valueStyle={{ color: '#faad14' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} lg={6}>
                            <Card bordered={false} className="status-card">
                                <Statistic
                                    title="This Month"
                                    value={statsData.thisMonth}
                                    prefix={<CalendarOutlined />}
                                    valueStyle={{ color: '#52c41a' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} lg={6}>
                            <Card bordered={false} className="status-card">
                                <Statistic
                                    title="Pending Pickup"
                                    value={statsData.pendingPickup}
                                    prefix={<FileTextOutlined />}
                                    valueStyle={{ color: '#ff4d4f' }}
                                />
                            </Card>
                        </Col>
                    </Row>

                    {/* Search Section */}
                    <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
                        <Col span={24}>
                            <Card title="Filter Date Range" className="profile-card">
                                <Row gutter={[16, 16]} align="middle">
                                    <Col xs={24} sm={12} lg={8}>
                                        <RangePicker
                                            style={{ width: '100%' }}
                                            value={[moment(this.state.startDate), moment(this.state.endDate)]}
                                            onChange={(dates) => {
                                                if (dates) {
                                                    this.setState({
                                                        startDate: dates[0].format('YYYY-MM-DD'),
                                                        endDate: dates[1].format('YYYY-MM-DD')
                                                    });
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col xs={24} sm={12} lg={4}>
                                        <Button
                                            type="primary"
                                            icon={<SearchOutlined />}
                                            onClick={() => {
                                                if (this.state.activeTab === '1') {
                                                    this.getTransactions();
                                                } else {
                                                    this.getReservations();
                                                }
                                            }}
                                            loading={this.state.load || this.state.loadReservations}
                                            block
                                        >
                                            Search
                                        </Button>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>

                    {/* Tabs Section */}
                    <Row gutter={[24, 24]}>
                        <Col span={24}>
                            <Card className="transactions-card">
                                <Tabs
                                    activeKey={this.state.activeTab}
                                    onChange={this.onTabChange}
                                    size="large"
                                    items={[
                                        {
                                            key: '1',
                                            label: (
                                                <span>
                                                    <FileTextOutlined />
                                                    Transaction History
                                                </span>
                                            ),
                                            children: this.renderRecords(),
                                        },
                                        {
                                            key: '2',
                                            label: (
                                                <span>
                                                    <CalendarOutlined />
                                                    Active Reservations
                                                </span>
                                            ),
                                            children: this.renderReservations(),
                                        },
                                    ]}
                                />
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default Transactions;